/** minPay, maxPay, gift — 빈 문자열이면 미사용. gift 가 있으면 경품 노출. */

function norm(s) {
  return (s || '').trim();
}

function hasGift(gift) {
  return norm(gift) !== '';
}

/** 금액 문자열이 0이 아닌 유효 금액인지 */
function isNonZeroPay(s) {
  const t = norm(s);
  if (t === '') return false;
  const n = Number(t.replace(/,/g, ''));
  return Number.isFinite(n) && n !== 0;
}

/**
 * 목록용 사례비 문구 (원 단위, 0원 미표출).
 * @param {string} minPay
 * @param {string} maxPay
 * @param {{ allowOneSided?: boolean }} [opts] 좌담회 편측 구간(min원~ / ~max원) 허용
 * @returns {string|null}
 */
function formatListPayText(minPay, maxPay, { allowOneSided = false } = {}) {
  const min = norm(minPay);
  const max = norm(maxPay);
  const minOk = isNonZeroPay(min);
  const maxOk = isNonZeroPay(max);

  if (!min && !max) return null;

  if (min && max && min === max) {
    return minOk ? `${min}원` : null;
  }

  if (min && max) {
    if (minOk && maxOk) return `${min}원~${max}원`;
    if (!minOk && maxOk) return `~${max}원`;
    if (minOk && !maxOk) return `${min}원~`;
    return null;
  }

  if (allowOneSided) {
    if (minOk) return `${min}원~`;
    if (maxOk) return `~${max}원`;
    return null;
  }

  if (minOk) return `${min}원`;
  if (maxOk) return `${max}원`;
  return null;
}

/**
 * @param {string|null} payText
 * @param {boolean} gift
 * @returns {{ parts: { iconClass: string, text: string }[] }|null}
 */
function buildRewardParts(payText, gift) {
  const parts = [];
  if (payText) parts.push({ iconClass: 'i-cash', text: payText });
  if (gift) parts.push({ iconClass: 'i-gift', text: '경품' });
  return parts.length > 0 ? { parts } : null;
}

/** 조사 참여하기·메인 조사 탭: 단일/구간/경품(적립금 + 경품 순, 아이콘 분리) */
export function formatSurveyReward({ minPay, maxPay, gift }) {
  const payText = formatListPayText(minPay, maxPay, { allowOneSided: false });
  return buildRewardParts(payText, hasGift(gift));
}

/** 좌담회: 차등 편측 구간 지원, 나머지는 조사와 동일 규칙 */
export function formatPanelReward({ minPay, maxPay, gift }) {
  const payText = formatListPayText(minPay, maxPay, { allowOneSided: true });
  return buildRewardParts(payText, hasGift(gift));
}

function toPayNumber(v) {
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function formatDetailWon(n) {
  return `${n.toLocaleString('ko-KR')}원`;
}

/**
 * 좌담회 상세/소개 — 사례비·소개비 문구.
 * 0원이면 빈 문자열(행 미표출). 하한 0 구간은 `~N원 (차등)`.
 * @param {{ minVal: unknown, maxVal: unknown, tpCd?: unknown }} args
 * @returns {string}
 */
export function formatOfflineDetailPay({ minVal, maxVal, tpCd }) {
  const minN = toPayNumber(minVal);
  const maxN = toPayNumber(maxVal);
  const tp = String(tpCd ?? '');

  if (minN == null && maxN == null) return '';

  const minOk = minN != null && minN !== 0;
  const maxOk = maxN != null && maxN !== 0;

  if (tp === 'D' && minN != null && maxN != null && minN !== maxN) {
    if (minOk && maxOk) return `${formatDetailWon(minN)} ~ ${formatDetailWon(maxN)} (차등)`;
    if (!minOk && maxOk) return `~${formatDetailWon(maxN)} (차등)`;
    if (minOk && !maxOk) return `${formatDetailWon(minN)}~ (차등)`;
    return '';
  }

  let single = null;
  if (minN != null && maxN != null && minN === maxN) single = minN;
  else if (maxN != null) single = maxN;
  else single = minN;

  if (single == null || single === 0) return '';
  return formatDetailWon(single);
}

/**
 * 좌담회 상세/소개 — 소개비. tpCd 가 N/빈값이면 미표출.
 * @param {{ minVal: unknown, maxVal: unknown, tpCd?: unknown }} args
 * @returns {string}
 */
export function formatOfflineDetailInvPay({ minVal, maxVal, tpCd }) {
  const tp = String(tpCd ?? '');
  if (tp === 'N' || tp === '') return '';
  return formatOfflineDetailPay({ minVal, maxVal, tpCd });
}
